/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setSwiper.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __00: 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import gsap from "gsap";

export function setSwiper() {
    const swiperPost = document.querySelector('.swiper-post');
    const swiperIntroduction = document.querySelectorAll('.swiper-introduction');
    const init = { loop: true, speed: 1000 }

    if (swiperPost) {
        /**
         * @name options
         * @description swiperのオプション
         */
        let options = {
            ...init,
            autoplay: { disableOnInteraction: false, delay: 2000, },
            slidesPerView: "auto",
            pagination: { el: ".post-slider__pagination", clickable: true, },
        }
        const swiper = new Swiper(swiperPost, Object.assign(options));
    }

    if (swiperIntroduction) {
        swiperIntroduction.forEach((element) => {
            let prevBtn = element.querySelector(".prev__btn");
            let nextBtn = element.querySelector(".next__btn");
            let nextArea = element.querySelector(".next__area");
            let slide = element.querySelectorAll(".swiper-slide:not(.swiper-slide-duplicate)");
            let currentNum = element.querySelector(".tool-box .current");
            let progress = element.querySelector(".tool-box .tool-box__progress");

            /**
             * @name currentNumSet
             * @description 現在のスライド番号を表示
             */
            const currentNumSet = () => {
                let currentIndex = element.swiper.realIndex + 1;
                currentNum.innerHTML = currentIndex;
            }

            /**
             * @name progressValueSet
             * @description 現在のスライド番号に合わせてプログレスバーの値を変更
             */
            const progressValueSet = () => {
                let max = progress.max;
                let currentIndex = element.swiper.realIndex + 1;
                let currentSlide = slide.length;
                let progressValue = Math.floor((currentIndex / currentSlide) * max);
                gsap.to(progress, { duration: 0.5, value: progressValue });
            }

            /**
             * @name options
             * @description swiperのオプション
             */
            let options = {
                ...init,
                speed: 500,
                slidesPerView: "auto",
                spaceBetween: 20,
                navigation: {
                    prevEl: prevBtn,
                    nextEl: nextBtn,
                },
                grabCursor: true,
                on: {
                    slideChange: () => {
                        currentNumSet();
                        progressValueSet();
                    }
                }
            }

            const swiper = new Swiper(element, Object.assign(options));
            nextArea.addEventListener("click", () => swiper.slideNext());
        });
    }
}